import {AEditor} from "@/views/editor/service/editor";
import {reactive} from "vue";
import {EActivityStatus, IActivityThemeImage} from "@/model/activity";
import {api} from "@/lib/api";
import {ServiceOrder} from "@/model/order";
import {Modal} from "ant-design-vue";
import {ThemeCategory} from "@/views/editor/service/theme/category";
import {IRender} from "@/views/editor/service/types";

export interface IThemeImagePreview {
    preview: string;
    loading: boolean;
    updateAt: Date;
    data: unknown;
}

export interface IThemeImageCategory {
    title: string;
    previews: IThemeImagePreview[];
}

export interface IThemeEditorImage {
    image: IActivityThemeImage
    preview: IThemeImagePreview
}

export class Theme {
    readonly noPic = 'https://static.pms.guandb.cn/media/system/null.jpg'
    readonly active = reactive({
        categories: {
            preheating: [
                {title: '主图', previews: [] as IThemeImagePreview[]},
                {title: '分享缩略', previews: [] as IThemeImagePreview[]},
                {title: '分享海报', previews: [] as IThemeImagePreview[]},
                {title: '背景图', previews: [] as IThemeImagePreview[]},
            ],
            active: [
                {title: '主图', previews: [] as IThemeImagePreview[]},
                {title: '分享缩略', previews: [] as IThemeImagePreview[]},
                {title: '分享海报', previews: [] as IThemeImagePreview[]},
                {title: '背景图', previews: [] as IThemeImagePreview[]},
            ],
            finished: [
                {title: '主图', previews: [] as IThemeImagePreview[]},
                {title: '分享缩略', previews: [] as IThemeImagePreview[]},
                {title: '分享海报', previews: [] as IThemeImagePreview[]},
                {title: '背景图', previews: [] as IThemeImagePreview[]},
            ],
        } as Record<EActivityStatus, IThemeImageCategory[]>,
        open: false,
        service: {serviceOrder: null as null | ServiceOrder},
    })
    category: ThemeCategory | null = null;

    constructor(readonly editor: AEditor) {
        for (const sk of [EActivityStatus.preheating, EActivityStatus.active]) {
            console.log(sk, editor.meta.theme[sk])
            editor.meta.theme[sk].images.forEach((i, k) => {
                this.active.categories[sk][k].previews = i.map(() => ({
                    preview: this.noPic,
                    loading: true,
                    updateAt: new Date(0),
                    data: null
                }))
            })
        }
    }

    async imagePreview(status: EActivityStatus, x: number, y: number): Promise<unknown> {
        // console.log(status, x, y, this.editor.meta.theme[status].images[x][y].draws.length)
        if (this.editor.meta.theme[status].images[x][y].draws.length == 0) {
            this.active.categories[status][x].previews[y].loading = false;
            this.active.categories[status][x].previews[y].preview = this.editor.meta.theme[status].images[x][y].image_url
            return Promise.resolve()
        }
        this.active.categories[status][x].previews[y].loading = true;
        const data: IRender = {
            activity: this.editor.meta,
            status: status,
        }
        const _br = this.editor.userAgent.branch(this.editor.active.preview.branch_id ?? '')
        if (_br) {
            data.branch = _br.meta
            data.brand = this.editor.userAgent.brands[_br.meta.brand_id].meta
        }

        return api<unknown, Blob>({
            url: `user/${this.editor.userAgent.meta.account.agent_id}/activity/image`,
            method: 'POST',
            data: Object.assign(data, {image: this.editor.meta.theme[status].images[x][y]}),
            responseType: 'blob'
        }).then((b: Blob) => {
            this.active.categories[status][x].previews[y].preview = URL.createObjectURL(b);
        }).finally(() => {
            this.active.categories[status][x].previews[y].loading = false;
        });
    }

    onSetting(x: number) {
        this.category = new ThemeCategory(this, x)
        this.active.open = true
    }

    onOrderShow() {
        this.editor.userAgent.newOrder('订制元素', this.editor.meta.activity_id).then((so) => {
            this.active.open = false
            this.active.service.serviceOrder = so
        }).catch((error) => Modal.error({content: error.message}))
    }
}
